import { useContext } from 'react';

import { CountryRiskContext } from './countryRiskContext';

/** Returns null outside CountryRiskProvider: badges are not shown there */
export const useCountryRiskContext = () => useContext(CountryRiskContext);
